<div class="flow-content">
  <div class="d-flex flex-column gap-4">
    <app-primary-back-button
      *ngIf="showBackToLogin$ | async"
      label="Back to Login"
      i18n-label
      (backClicked)="goToLogin()" />
    <app-logo [width]="'5.25rem'" [height]="'3rem'" [logoImage]="'assets/logo/navy/spp-logo.svg'" />
    <span class="header-title" i18n>Enrol New Employer</span>
  </div>
  <div>
    <app-stepper [selectedIndex]="currentStep$ | async">
      <cdk-step label="Employer Information" i18n-label />
      <cdk-step label="Contact Personnel" i18n-label />
    </app-stepper>
    <ng-container *ngIf="!(isLoading$ | async); else loading">
      <div class="pt-2">
        <ng-container *ngComponentOutlet="currentStepComponent$ | async" />
      </div>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="d-flex flex-column gap-4">
    <ng-container *appRepeat="3">
      <lib-loading-shimmer width="100%" height="20rem" />
      <hr class="m-0" />
    </ng-container>
  </div>
</ng-template>
